// External
import React, { Component } from "react";
import { connect } from "react-redux";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import { removeInfoFeedMessage, setInfoFeedMessage } from "../../store/actions";
import { cloneDeep, debounce, filter, get as _get } from "lodash";
import Moment from "moment";
import { containsCoordinate } from "ol/extent";
import * as olProj from "ol/proj";

// Internal
import FloatHeader from "../theme/headers/FloatHeader";
import { defaultMapState } from "./CreateSite";
import InfoTileFeed from "../subscreens/InfoFeed";
import FilterDisplay from "../subscreens/FilterDisplay";
import {
  filterAndSortItems,
  handleFilterDeletion,
  handleSearchChange,
} from "../../utils/FilterDisplayUtils";
import SiteNoteModal from "../theme/modals/SiteNoteModal";
import SiteFilterModal from "../theme/modals/SiteFilterModal";

import {
  createRouteSeat,
  deleteRouteSeatSite,
  matchSiteCanvassToCampaign,
  pullCampaignSites,
  pullSiteNoteCategories,
  pullSiteNotes,
  pullSiteRoutes,
  removeSiteRoute,
  updateOrCreateRouteSeatSite,
  updateOrCreateSiteRoute,
} from "../../store/api/calls";

import Input from "../theme/forms/Input";
import Tabs from "../theme/menus/Tabs";
import DraggableSiteCard from "../cards/DraggableSiteCard";
import SiteCard from "../cards/SiteCard";
import DroppableRouteSeatListItem from "../maps/listItems/DroppableRouteSeatListItem";
import BasicButton from "../theme/buttons/BasicButton";
import SimpleColorPicker from "../theme/colorPickers/simpleColorPicker";
import scrollIntoView from "scroll-into-view-if-needed";
import { centroidStyle } from "../maps/olStyles";

import BaseMap from "../maps/BaseMap";
import { groupedPointStyle } from "../maps/BaseMapStyles";
import { withRouter } from "../../utils/withRouter";

class RouteEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ...defaultMapState,
      nextChunk: 1,
      chunkSize: 100,
      bounds: undefined,
      lockSubmit: false,
      sideBarClosed: false,
      filterAdHoc: 1,
      showColorEdit: false,
      focusedMarker: 0,
      cardFocused: false,
      showAddRouteInput: false,
      addRouteValue: "",
      siteRouteSideBarClosed: true,
      focusedSites: [],
      selectedSites: [],
      sites: [],
      siteRoutes: [],
      activeEditRouteId: null,
      editActiveRouteName: false,
      editActiveRoute: false,
      activeRouteSeat: null,
      activeHoverRoute: null,
      mapType: "positron",
      mode: "SiteRoutes",
      smartOrder: false,
      columns: {
        sites: [],
      },
      siteCanvassData: {},
      pageError: false,
      errMsg: "Whoops! There's been a server error.",
      googleApiLoaded: false,

      // filter state
      filterModalOpen: false,
      filters: {
        id: "sites",
        keyword: "",
        keywordPersist: "",
        noteTags: [],
        sortBy: "name",
        sortDsc: false,
        searchFields: [
          "name",
          "city",
          "zip5",
          "statecode",
          "addressline1",
          "addressline2",
          "description",
          "noteString",
        ],
        sortFields: [
          {
            display: "Name",
            value: "name",
          },
          {
            display: "Creation Date",
            value: "created_at",
          },
          {
            display: "City",
            value: "city",
          },
          {
            display: "Number of Notes",
            value: "note_count",
          },
        ],
      },
      routeFilters: {
        id: "routes",
        keyword: "",
        keywordPersist: "",
        noteTags: [],
        sortBy: "name",
        sortDsc: false,
        searchFields: ["siteroute_name"],
        sortFields: [
          { display: "Name", value: "siteroute_name" },
          { display: "Creation Date", value: "created_at" },
        ],
      },
      hoveredFeatures: null,
      encodedSites: {
        type: "FeatureCollection",
        features: [],
      },
      blockPopup: false,
      blockHoverUpdate: false,
      pseudoHoveredFeatures: [],
    };

    this.olMap = React.createRef();

    this.defaultStyleConfig = {
      count: null,
      radius: 5,
      fill: "#792CC7",
      stroke: "#792CC7",
      name: null,
      showLabel: false,
      fillOpacity: 0.6,
    };

    this.lassoedColor = "#eaa448";
    this.hoverColor = "#c60115";

    this.defaultStyle = centroidStyle(this.defaultStyleConfig);

    // corresponds to width var set in maps.scss
    this.sideBarColWidth = 280;

    // d3 scheme paired
    this.routeColors = [
      "#a6cee3",
      "#1f78b4",
      "#b2df8a",
      "#33a02c",
      "#fb9a99",
      "#e31a1c",
      "#fdbf6f",
      "#ff7f00",
      "#cab2d6",
      "#6a3d9a",
      "#ecb012",
      "#b15928",
    ];
  }

  componentDidMount() {
    if (this.props.focusedCampaign.id) {
      this.handleMountOrCampaignUpdate({});
    } else {
      setTimeout(this.handleMountOrCampaignUpdate.bind(this, {}), 600);
    }

    this.setState({
      encodedSites: this.encodeSites(this.props.sites, "site-points"),
    });

    pullSiteNotes();
    pullSiteNoteCategories();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.sites !== this.props.sites ||
      prevProps.siteRoutes !== this.props.siteRoutes ||
      prevState.activeEditRouteId !== this.state.activeEditRouteId ||
      prevState.pseudoHoveredFeatures !== this.state.pseudoHoveredFeatures ||
      prevState.selectedSites !== this.state.selectedSites
    ) {
      this.setState({
        encodedSites: this.encodeSites(this.props.sites, "site-points"),
      });
    }
  }

  findSiteRoutesThatContainSite = (site) => {
    return (
      this.props.siteRoutes &&
      this.props.siteRoutes.filter((route) => {
        return (
          route.routeseats &&
          route.routeseats
            .reduce((agg, seat) => {
              return [
                ...agg,
                ...(seat.sites || []).map((site) => site.site_id),
              ];
              // return seat.sites && seat.sites.find((routeSite) => routeSite.site_id === site.id);
            }, [])
            .indexOf(site.id) > -1
        );
      })
    );
  };

  encodeSites = (sites, source) => {
    const { activeEditRouteId } = this.state;

    return {
      type: "FeatureCollection",
      features: sites.map((site) => {
        // site -> list of routes that that site exists within
        // sites can be apart of multiple routes, and to make sure that we style each site properly
        // we need to catch all of those routes. The default displayed route a site is in is its first
        // route.
        const routeData = this.findSiteRoutesThatContainSite(site) || [];
        const displayedRoute =
          routeData?.find(
            (route) => route.siteroute_id === activeEditRouteId
          ) || routeData[0];

        return {
          type: "Feature",
          id: site.id,
          source: source,
          geometry: {
            type: "Point",
            coordinates: [
              +site.lon || +site.longitude || 0,
              +site.lat || +site.longitude || 0,
            ],
          },
          properties: {
            label: site.name,
            disabled:
              this.state.mode === "creating" && source === "site-points",
            data: { ...site, routeSeats: displayedRoute?.routeseats },
            groupColor: displayedRoute?.hex_color || "#6a3d9a",
            inGroup: !!displayedRoute,
            routeId: displayedRoute?.siteroute_id,
            routeName: displayedRoute?.siteroute_name,
            routeCreatedAt: displayedRoute?.created_at,
            editing: displayedRoute?.siteroute_id === activeEditRouteId,
            pseudoHover:
              this.state.pseudoHoveredFeatures?.indexOf(site.id) > -1,
          },
        };
      }),
    };
  };

  // TODO: MAKE SURE THAT URL PARAMETER MATCHES THE SELECTED CAMPAIGN, BY SETTING THE CAMPAIGN TO THE SITECANVASS CAMPAIGN PARENT!
  handleMountOrCampaignUpdate = (options = {}) => {
    this.setState({ loading: true });
    let sites;
    const {params} = this.props;

    let siteFlags = Object.assign(options, {
      filter_ad_hoc: this.state.filterAdHoc,
    });
    matchSiteCanvassToCampaign(params.sitecanvass_id)
      .then((data) => {
        this.setState({ siteCanvassData: data || {} });
      })
      .then(() => pullCampaignSites({ ...siteFlags, notes: 1 }))
      .then((res) => {
        if (res) {
          sites = res.data;
          pullSiteRoutes(params.sitecanvass_id).then((siteroutes) => {
            let columns = { ...this.state.columns };
            columns.sites = sites;
            siteroutes.forEach((sr) => this.manageOnLoadStyle(sr));
            this.setState({ sites, columns, loading: false });
          });
        }
      });
  };

  // update the site cards based off of state maintained in the drag and drop columns
  // b/c site cards are dependent on that structure to render.
  handleBoundsChange(bounds) {
    let sites = this.props.sites.filter((item) => {
      return containsCoordinate(
        bounds,
        olProj.fromLonLat([parseFloat(item.lon), parseFloat(item.lat)])
      );
    });

    let columns = cloneDeep(this.state.columns);
    columns.sites = sites;

    this.setState({ columns, sites, bounds });
  }

  getActiveEditRoute = () => {
    if (!this.state.activeEditRouteId) return {};
    return (
      this.props.siteRoutes.find(
        (d) => +d.siteroute_id === +this.state.activeEditRouteId
      ) || {}
    );
  };

  handleDblClick = () => {
    // called when lassos clear, need to reset default points, active edit route points, and hide points that have been filtered out.
    let visibleSites = this.filterSites(this.state.sites).map((s) => s.id);
    let hiddenSites = this.state.sites
      .filter((s) => !visibleSites.find((v) => v === s.id))
      .map((site) => site.id);
    let routeSites = [];
    // also remove selected message when cleared.
    this.props.removeInfoFeedMessage("count_selected_sites");

    this.state.activeEditRouteId &&
      this.getActiveEditRoute().routeseats.forEach((seat) => {
        if (seat.sites) {
          let ids = this.filterSites(seat.sites).map((s) => s.site_id);
          routeSites = routeSites.concat(ids);
        }
      });
  };

  handleDeselectAllPoints = () => {
    this.setState({ selectedSites: [] });
    this.props.removeInfoFeedMessage("count_selected_sites");
  };

  // get the sites that were evaluated to be contained in the drawn polygon(s)
  updateSelectedSites(point) {
    const pointId = point.properties.data.id;

    const site = this.props.sites.find((s) => s.id === pointId);

    this.props.removeInfoFeedMessage("count_selected_sites");

    let selectedSites;
    if (
      !this.state.selectedSites.find((s) => s.properties.data.id === pointId)
    ) {
      selectedSites = [...this.state.selectedSites, point];
    } else {
      selectedSites = [
        ...this.state.selectedSites.filter(
          (s) => s.properties.data.id !== pointId
        ),
      ];
    }

    this.setState({ selectedSites });

    this.props.setInfoFeedMessage({
      id: "count_selected_sites",
      msg: selectedSites.length + " Total Sites Selected",
      timeoutLength: selectedSites.length ? 9999999999 : 3000,
      onClick: selectedSites.length ? this.handleDeselectAllPoints : null,
      onClickName: "Deselect All",
      cantClose: true,
    });
  }

  addLassoToSeat = (rs_id, sr_id) => {
    let selectedIds = [];
    let editRoute = cloneDeep(this.getActiveEditRoute());
    let routeseat_index = editRoute.routeseats.findIndex(
      (r) => r.routeseat_id === rs_id
    );
    // defining here so all colors can be kept in sync with the assigned route color
    let routeSeatSiteIds = editRoute.routeseats[routeseat_index].sites.map(
      (s) => s.site_id
    );

    // filter out sites by text and then remove any sites already in the seat.
    let selectedSites = this.filterSites(
      this.state.selectedSites.map((s) => s.properties.data)
    );
    selectedSites = selectedSites.filter(
      (s) =>
        !editRoute.routeseats[routeseat_index].sites.find(
          (rss) => rss.site_id === s.id
        )
    );

    if (selectedSites.length > 0) {
      let columns = { ...this.state.columns };

      if (!columns[rs_id]) {
        columns[rs_id] = [];
      }

      let requestData = {
        routeseat: rs_id,
        siteroute: sr_id,
      };

      this.setState({ loading: true });

      // bulk edit sites.
      selectedSites.forEach((item, index) => {
        selectedIds.push(item.id);
        requestData.site = item.id;
        requestData.site_order_position =
          editRoute.routeseats[routeseat_index].sites.length + index + 1;
        updateOrCreateRouteSeatSite(requestData).then((res) => {
          item.routeseatsite_id = res.routeseatsite_id;
          item.site_id = item.id;
          columns[rs_id].push(item);
          // keep the edit route in sync so ppl can't add dupe sites to a seat in the same session.
          editRoute.routeseats[routeseat_index].sites.push(item);
        });

        if (index === selectedSites.length - 1) {
          // NOTE: since the api call above is async, for large updates it will stop the loading indicator before truly done.
          // The new routeseatsites are linked to the data coming in via props, so all the new sites will still render regardless of this set state.
          this.setState({
            loading: false,
            columns,
            activeEditRouteId: editRoute.siteroute_id,
          });

          this.handleDeselectAllPoints();

          // push a message into redux store to have an info tile display what just happened.
          let msg =
            selectedSites.length > 1
              ? selectedSites.length + " sites added"
              : selectedSites.length + " site added";
          this.props.setInfoFeedMessage({
            id: "count_added_sites",
            msg,
            cantClose: true,
          });
        }
      });
    } else {
      this.props.setInfoFeedMessage({
        id: "no_addition",
        msg: "Nothing new to add",
      });
    }
  };

  updateSideView(mode) {
    this.setState({ mode });
  }

  getActive(mode) {
    return this.state.mode === mode ? "active-db-indicator" : "";
  }

  handleSeatAdd() {
    let data = {
      siteroute: this.getActiveEditRoute().siteroute_id,
      canvasser_type: null,
    };

    createRouteSeat(data).then((res) => {
      let columns = cloneDeep(this.state.columns);
      columns[res.routeseat_id] = [];
      this.setState({ columns });
    });
  }

  setActiveRouteSeat(routeseat) {
    this.setState({ activeRouteSeat: routeseat });
  }

  // used for showing sites assigned to route w/o activating that route.
  setActiveHoverRoute(route) {
    let routeSeatIds = route.routeseats.reduce((agg, cur) => {
      return [...agg, ...cur.sites.map((site) => site.site_id)];
    }, []);

    this.setState({
      hoveredFeatures: routeSeatIds,
      hoveredSource: "site-points",
      blockPopup: true,
    });
  }

  removeActiveHoverRoute() {
    this.setState({
      hoveredFeatures: null,
      hoveredSource: null,
      blockPopup: false,
    });
  }

  // add or remove marker styles based on the assigned route color.
  manageRouteSiteStyle(route, styleConfig) {
    let site_ids = [];

    route &&
      route.routeseats.forEach((seat) => {
        if (seat.sites) {
          let ids = this.filterSites(seat.sites).map((s) => s.site_id);
          site_ids = site_ids.concat(ids);
        }
      });
  }

  manageHoverStyle = (route, add = true) => {
    let styleConfig;
    if (add) {
      styleConfig = {
        fill: route.hex_color,
        radius: 8,
        fillOpacity: 0.7,
        strokeWidth: 3,
      };
    } else {
      styleConfig = { fill: route.hex_color };
    }
    this.manageRouteSiteStyle(route, styleConfig);
  };

  manageOnLoadStyle = (route) => {
    this.manageRouteSiteStyle(route, { fill: route.hex_color });
  };

  setActiveEditRoute(route) {
    // reset the style first.
    let siteIds = this.filterSites(this.state.sites).map((s) => s.id);
    //check that you haven't already assigned
    if (
      this.state.activeEditRouteId &&
      this.getActiveEditRoute().siteroute_id === route.siteroute_id
    ) {
      this.setState(
        this.setState({
          activeEditRouteId: null,
          mode: "Sites",
          blockHoverUpdate: false,
          blockPopup: false,
          hoveredFeatures: null,
        })
      );
      return;
    }

    let columns = { ...this.state.columns };
    let seats = 0;
    let focusedSites = [];

    // loop through each seat to see which sites are included.
    route.routeseats.forEach((item) => {
      seats++;
      columns[item.routeseat_id] = [];

      if (item.sites) {
        focusedSites = [...focusedSites, ...item.sites];
        let sortedItems = item.sites
          .slice()
          .sort((a, b) => a.site_order_position - b.site_order_position);

        sortedItems.forEach((site) => {
          // draggable Ids must be unique across the entire DragDropContext
          columns[item.routeseat_id].push(site);
        });
      }
    });

    // re-add any selected sites styles if they exist.
    this.setState({
      activeEditRouteId: route.siteroute_id,
      columns,
      seats,
      mode: "Sites",
      focusedSites,
    });
  }

  addRoute() {
    this.setState({ showAddRoute: true });
  }

  handleAddRouteInputChange(val) {
    this.setState({ addRouteValue: val });
  }

  submitRoute() {
    this.setState({ lockSubmit: true });
    // TODO: figure out best way to assign a random route color here.
    let hex_color =
      this.routeColors[Math.floor(Math.random() * this.routeColors.length)];
    const {params} = this.props;


    updateOrCreateSiteRoute({
      sitecanvass: params.sitecanvass_id,
      name: this.state.addRouteValue,
      hex_color,
    })
      .then((res) => {
        this.setState({
          showAddRoute: false,
          addRouteValue: "",
          lockSubmit: false,
        });
      })
      .catch((err) => this.setState({ lockSubmit: false }));
  }

  deactivateRoute(siteroute_id) {
    const {params} = this.props;

    if (_get(this.getActiveEditRoute(), "siteroute_id", 0) === siteroute_id) {
      this.setState({
        activeEditRouteId: null,
        blockPopup: false,
        blockHoverUpdate: false,
      });
    }

    removeSiteRoute({
      sitecanvass: params.sitecanvass_id,
      siteroute_id,
      is_active: 0,
    }).then((res) => {});
  }

  tabClickHandler(mode) {
    if (mode === "Sites") {
      this.setState({
        mode,
        filters: {
          ...this.state.filters,
          keywordPersist: this.state.filters.keyword,
        },
      });
    } else {
      this.setState({
        mode,
        routeFilters: {
          ...this.state.routeFilters,
          keywordPersist: this.state.routeFilters.keyword,
        },
      });
    }
  }

  filterSites(data) {
    if (this.state.filters.keyword === "") return data;

    const predicate = (siteObject) => {
      //where o is the site object. We filter across every key to filter

      if (Array.isArray(siteObject.notes)) {
        siteObject.noteString = "";
        siteObject.notes.map((note) => {
          siteObject.noteString += " " + String(note.category);
          siteObject.noteString += note.note ? " " + String(note.note) : "";
        });
      }

      /// only search in some fields to speed up the process
      let fieldsToSearch = [
        "name",
        "city",
        "zip5",
        "statecode",
        "addressline1",
        "addressline2",
        "description",
        "noteString",
      ];
      for (const idx in fieldsToSearch) {
        const v = siteObject[fieldsToSearch[idx]];

        const coercedValue = String(v);

        if (
          coercedValue.trim().toLowerCase().includes(this.state.filters.keyword)
        ) {
          return true;
        }
      }
      return false;
    };

    //check for the presence of this.state.filters.keyword in various fields
    //go through unknown objects and check for presence in values
    return filter(data, predicate);
  }

  getFilteredSiteCount(sites) {
    if (sites.length === 0) {
      // no need to filter
      return 0;
    }

    return this.filterSites(sites).length;
  }

  handlePointsOnFilter() {
    let sites = cloneDeep(this.state.columns.sites);
    let visibleSites = this.filterSites(sites);
    let focusedIds = this.filterSites(this.state.focusedSites).map(
      (s) => s.site_id
    );
    let visibleIds = [];
    let hiddenIds = [];

    sites.forEach((s) => {
      if (visibleSites.find((v) => v.id === s.id)) {
        visibleIds.push(s.id);
      } else {
        hiddenIds.push(s.id);
      }
    });
  }

  toggleColorSelector() {
    this.setState({ showColorEdit: !this.state.showColorEdit });
  }

  chooseColor(color) {
    let updated = { ...this.getActiveEditRoute() };
    updated.hex_color = color;
    // only allow color to be set if there is an activeEditRoute to avoid race conditions.
    // Set Active Edit Route color to selected and probably need to update it with an api call here too.
    updateOrCreateSiteRoute({
      siteroute_id: updated.siteroute_id,
      hex_color: color,
    }).then((res) => {
      this.toggleColorSelector();
      let activeEditRoute = cloneDeep(this.getActiveEditRoute());
      this.setState({
        activeEditRouteId: activeEditRoute.siteroute_id,
      });
    });
  }

  changeRouteName = () => {
    const name = this.state.editingActiveRouteName;
    if (name !== this.getActiveEditRoute().siteroute_name) {
      updateOrCreateSiteRoute({
        siteroute_id: this.state.activeEditRouteId,
        name,
      }).then(() => {
        let ar = this.getActiveEditRoute();
        if (!this.props.siteroutes_error) ar.siteroute_name = name;
        this.setState({ editActiveRoute: false });
      });
    } else {
      this.setState({ editActiveRoute: false });
    }
  };

  changeSmartOrderStatus = (bool = false) => {
    updateOrCreateSiteRoute({
      siteroute_id: this.state.activeEditRouteId,
      smart_ordered: bool,
    }).then(() => {
      let ar = this.getActiveEditRoute();
      if (!this.props.siteroutes_error) ar.smart_ordered = bool;
    });
  };

  onMarkerHover(point) {
    if (!point) {
      this.setState({ focusedMarker: 0 });
      return;
    }

    let id = point.get("id");
    this._setFocusedMarker(id, { center: false, scrollToFixed: true });
  }

  setScrollOnFocus(key, options) {
    let id = `site-card-${key}`;
    if (options.scrollToFixed) {
      id = "fixed-sitecard-div";
    }

    if (key && document.getElementById(id)) {
      scrollIntoView(document.getElementById(id), {
        behavior: "smooth",
        scrollMode: "if-needed",
      });
    }
  }

  _setFocusedMarker(key, options) {
    if (!options) options = {};
    const { noState, scroll, exiting, cardFocused } = {
      noState: false,
      scroll: false,
      exiting: false,
      cardFocused: false,
      ...options,
    };

    // if exiting, set the focused id to 0 so focusing stops.
    let focusedId = exiting ? 0 : key;

    if (!noState) {
      this.setState(
        {
          focusedMarker: focusedId,
          cardFocused,
        },
        () => {
          if (scroll) this.setScrollOnFocus.bind(this, key, options);
        }
      );
    }
  }

  _renderAddRouteButtons() {
    if (this.state.mode !== "SiteRoutes") {
    } else if (this.state.showAddRoute) {
      return (
        <div
          className="mapButtonsPadding"
          style={{ backgroundColor: "white", height: "16rem" }}
        >
          <div style={{ backgroundColor: "white" }}>
            <Input
              type="text"
              onChange={this.handleAddRouteInputChange.bind(this)}
              placeholder="Site Route Name"
              value={this.state.addRouteValue}
            />
            <BasicButton
              disabled={
                this.state.addRouteValue === "" || this.state.lockSubmit
              }
              on_click={this.submitRoute.bind(this)}
              aria_label="Submit New Route"
              label="Submit Route"
              className="mapButton"
            />
          </div>
        </div>
      );
    } else {
      return (
        <div
          className="mapButtonsPadding"
          style={{ backgroundColor: "white", height: "8rem" }}
        >
          <BasicButton
            on_click={this.addRoute.bind(this)}
            aria_label="Add A Route"
            label="Add A Route"
            className={["mapButton", "primary"]}
          />
        </div>
      );
    }
  }

  _renderSideBarClusterTopDisplay() {
    let tabs = [
      {
        display: "SiteRoutes",
        active: this.state.mode === "SiteRoutes",
        onClick: this.tabClickHandler.bind(this, "SiteRoutes"),
      },
      {
        display: "Sites",
        active: this.state.mode === "Sites",
        onClick: this.tabClickHandler.bind(this, "Sites"),
      },
    ];

    return (
      <div className="side-menu-title">
        <h3 className="primary-text" style={{ textAlign: "center" }}>
          {this.state.siteCanvassData.name}
        </h3>
        <Tabs
          // style={{padding: '0 4rem !important'}}
          tabs={tabs}
          center={true}
          style={{ marginBottom: "5px" }}
        />
      </div>
    );
  }

  // Determine and return which chunk of the site cards should be rendered.
  chunkSiteCardList(sites) {
    if (this.state.nextChunk === 1) {
      return sites.slice(0, 100);
    } else {
      return sites.slice(
        (this.state.nextChunk - 1) * this.state.chunkSize,
        this.state.nextChunk * this.state.chunkSize
      );
    }
  }

  // this ensures we don't offset too far forwards.
  getMaxSiteChunk() {
    let sites = this.filterSites(this.state.sites);
    return Math.floor(sites.length / this.state.chunkSize) + 1;
  }

  // get a human readable label
  getChunkLabel(max_min = "min") {
    // always filter the list to keep the site counts in sync everywhere.
    let sites = this.filterSites(this.state.sites);

    if (sites.length === 0) return 0;

    // get the sites at the given offset
    sites = sites.slice(
      (this.state.nextChunk - 1) * this.state.chunkSize,
      this.state.nextChunk * this.state.chunkSize
    );

    if (max_min === "max") {
      if (sites.length >= this.state.chunkSize) {
        // we haven't reached the end, so just calc the length
        return this.state.chunkSize * this.state.nextChunk;
      } else {
        // we have reached the end, so adjust.
        return this.state.chunkSize * (this.state.nextChunk - 1) + sites.length;
      }
    } else {
      // offset the zero based index for the starting label.
      return (this.state.nextChunk - 1) * this.state.chunkSize + 1;
    }
  }

  _renderSideBarSiteList() {
    if (this.state.mode !== "Sites") return null;
    // get a copy of state in the order they have been set in.
    let focusedSite = this.props.sites.find(
      (s) => s.id === this.state.focusedMarker
    );
    let sites = cloneDeep(this.props.sites);

    sites = filterAndSortItems(sites, this.state.filters).filter((site) => {
      return this.state.visibleSiteIds.indexOf(site.id) > -1;
    });

    if (focusedSite && !this.state.cardFocused) {
      sites = sites.filter((s) => s.id !== focusedSite.id);
    }

    let value =
      this.state.filters.keywordPersist !== ""
        ? { value: this.state.filters.keyword }
        : {};

    const debouncedSiteSearch = debounce((query) => {
      const stateChanges = handleSearchChange(query);
      this.setState(
        {
          ...stateChanges[0],
          filters: {
            ...this.state.filters,
            keyword: stateChanges[1],
          },
        },
        this.handlePointsOnFilter.bind(this)
      );
    }, 300);

    sites = this.chunkSiteCardList(sites);

    return (
      <div className="side-menu-body container">
        <FilterDisplay
          filters={this.state.filters}
          openFilterModal={() => {
            this.setState({ filterModalOpen: true });
          }}
          handleFilterDeletion={(filterType, val, filters) => {
            this.setState({
              filters: handleFilterDeletion(filterType, val, filters),
            });
          }}
          handleSearchChange={(val) => {
            this.setState({
              filters: { ...this.state.filters, keywordPersist: "" },
            });
            debouncedSiteSearch(val);
          }}
          handleSortUpdate={(val) => {
            this.setState({ filters: { ...this.state.filters, sortBy: val } });
          }}
          handleSortDirectionChange={() =>
            this.setState({
              filters: {
                ...this.state.filters,
                sortDsc: !this.state.filters.sortDsc,
              },
            })
          }
          value={value}
        />

        <div className="sidebar-filter-input side-bar-switch-label">
          <Input
            type="switch"
            title="Show Ad Hoc Sites"
            onChange={() =>
              this.setState(
                { filterAdHoc: this.state.filterAdHoc === 0 ? 1 : 0 },
                this.handleMountOrCampaignUpdate.bind(this)
              )
            }
          />
        </div>
        <Droppable droppableId={"sites"}>
          {(provided) => (
            <div ref={provided.innerRef}>
              {/* THIS IS EVERYTHING ELSE, PAGINATED IN SETS OF 100*/}
              {sites.map((item, index) => {
                return (
                  <DraggableSiteCard
                    key={item.name + "_" + item.id}
                    index={index}
                    id={`site-card-${item.id}`}
                    focused={
                      item.id === this.state.focusedMarker &&
                      !this.state.cardFocused
                    }
                    draggableId={`${item.id}`}
                    data={item}
                    onMouseEnter={() => {
                      this.setState({
                        hoveredFeatures: [item.id],
                        hoveredSource: "site-points",
                      });
                    }}
                    onMouseLeave={() => {
                      this.setState({
                        hoveredFeatures: [],
                        hoveresSource: null,
                      });
                    }}
                  />
                );
              })}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </div>
    );
  }

  generatePointHoverCard = (route, feature) => {
    const featureData = feature.properties.data;
    console.log(route);
    return (
      <div className="point-hover-card">
        {!!route.routeseats && (
          <div>
            Route
            {this.generateSiteRouteListItem(route, true)}
          </div>
        )}
        <div style={{ marginTop: route.routeseats ? 8 : 0 }}>
          Site
          <SiteCard
            key={featureData.id}
            index={0}
            id={`site-card-${featureData.id}`}
            focused={true}
            name={featureData.name}
            data={featureData}
          />
        </div>
      </div>
    );
  };

  generateSiteRouteListItem = (item, disableHover = false) => {
    return (
      <div
        className="side-menu-list-obj"
        key={item.siteroute_id}
        onMouseEnter={
          !disableHover ? this.setActiveHoverRoute.bind(this, item) : null
        }
        onMouseLeave={
          !disableHover ? this.removeActiveHoverRoute.bind(this, item) : null
        }
      >
        <div
          className="list-obj-inner-wrapper"
          style={{ borderLeftColor: item.hex_color }}
        >
          <i
            style={{ fontSize: "1.5rem" }}
            className="remove-seat-icon fas fa-trash-alt fa-pull-right"
            title="Delete Site Route"
            onClick={this.deactivateRoute.bind(this, item.siteroute_id)}
          ></i>
          <div onClick={this.setActiveEditRoute.bind(this, item)}>
            <div className={"obj-title"}>{item.siteroute_name}</div>
            <div className="obj-data">Seats: {item.routeseats.length}</div>
            <div className="obj-data">
              Created On: {new Moment(item.created_at).format("YYYY-MM-DD")}
            </div>
          </div>
        </div>
      </div>
    );
  };

  _renderSiteRoutes() {
    if (this.state.mode !== "SiteRoutes" || !this.props.siteRoutes) return null;

    let routes = filterAndSortItems(
      this.props.siteRoutes,
      this.state.routeFilters
    ).map((item) => {
      return this.generateSiteRouteListItem(item);
    });
    let value =
      this.state.routeFilters.keywordPersist !== ""
        ? { value: this.state.routeFilters.keyword }
        : {};

    const debouncedRouteSearch = debounce((query) => {
      const stateChanges = handleSearchChange(query);
      this.setState(
        {
          ...stateChanges[0],
          routeFilters: {
            ...this.state.routeFilters,
            keyword: stateChanges[1],
          },
        },
        this.handlePointsOnFilter.bind(this)
      );
    }, 300);

    return (
      <div className="side-bar-scroll">
        <div className="side-menu-body container">
          <FilterDisplay
            hideModalButton
            filters={this.state.routeFilters}
            handleSearchChange={(val) => {
              this.setState({
                routeFilters: {
                  ...this.state.routeFilters,
                  keywordPersist: "",
                },
              });
              debouncedRouteSearch(val);
            }}
            handleSortUpdate={(val) => {
              this.setState({
                routeFilters: { ...this.state.routeFilters, sortBy: val },
              });
            }}
            handleSortDirectionChange={() =>
              this.setState(
                {
                  routeFilters: {
                    ...this.state.routeFilters,
                    sortDsc: !this.state.routeFilters.sortDsc,
                  },
                },
                () =>
                  filterAndSortItems(
                    this.props.siteRoutes,
                    this.state.routeFilters
                  )
              )
            }
            value={value}
          />
        </div>

        {routes}
      </div>
    );
  }

  _renderSiteRouteSeats() {
    if (!this.state.activeEditRouteId || !this.props.siteRoutes) return null;
    let activeRoute = this.getActiveEditRoute();

    let siteroute_id = activeRoute && activeRoute.siteroute_id;
    let activeRouteSeats = cloneDeep(activeRoute.routeseats);
    let sortedSeats = activeRouteSeats.sort(
      (a, b) => a.seat_order_position - b.seat_order_position
    );

    let seats = sortedSeats.map((item, index) => {
      let sites = cloneDeep(this.state.columns[item.routeseat_id]);
      return (
        <DroppableRouteSeatListItem
          onClick={this.setActiveRouteSeat.bind(this, item)}
          seatType={item.canvasser_type_id}
          siteRouteId={activeRoute.siteroute_id}
          routeSeatId={item.routeseat_id}
          sites={sites}
          showDelete={true}
          index={index}
          key={item + "_" + index}
          color={activeRoute.hex_color}
          activeSeat={
            this.state.activeRouteSeat &&
            this.state.activeRouteSeat.routeseat_id === item.routeseat_id
          }
          syncSiteColumns={this.syncSiteColumnsAfterDelete.bind(this)}
          syncSeatColumns={this.syncSeatColumnsAfterDelete.bind(this)}
          addRoutes={() => this.addLassoToSeat(item.routeseat_id, siteroute_id)}
          loading={this.props.siteroutes_loading}
          sitesSelected={this.state.selectedSites}
          onMouseEnterSite={(site_id, options) => {
            this.setState({
              hoveredFeatures: [site_id],
              hoveredSource: "site-points",
              blockPopup: false,
              blockHoverUpdate: true,
            });
            // this._setFocusedMarker(site_id, options);
          }}
          onMouseLeaveSite={(site_id, options) => {
            this.setState({
              blockPopup: true,
              hoveredSource: "site-points",
              hoveredFeatures: sites.map((site) => site.site_id || site.id),
            });
          }}
          onMouseEnter={() => {
            this.setState({
              hoveredFeatures: sites?.map((site) => site.site_id || site.id),
              hoveredSource: "site-points",
              blockPopup: true,
            });
          }}
          onMouseLeave={() => {
            this.setState({
              hoveredFeatures: null,
              hoveredSource: null,
              blockHoverUpdate: false,
              blockPopup: false,
            });
          }}
          // onSiteDelete={(routeseat_id, site_id) => {
          //   const route = {...this.getActiveEditRoute()}
          //   const rs_idx = route.routeseats.findIndex(d => routeseat_id === d.routeseat_id)
          //   if (rs_idx > -1) {
          //     const rs = route.routeseats[rs_idx];
          //     rs.sites = rs.sites.filter(d => site_id !== d.site_id)
          //     route.routeseats[rs_idx] = rs;
          //   }
          // }}
        />
      );
    });

    return (
      <>
        <div className="container side-bar-scroll">{seats}</div>
        <div
          className="mapButtonsPadding"
          style={{ backgroundColor: "white", height: "8rem" }}
        >
          <BasicButton
            on_click={this.handleSeatAdd.bind(this)}
            aria_label="Add A Seat"
            label="Add A Seat"
            className={["mapButton", "primary"]}
          />
        </div>
      </>
    );
  }

  _renderSiteRouteSlideMenu = () => {
    let activeRoute = this.getActiveEditRoute();

    return (
      <div
        id="site-route-slide-menu"
        className={`no-print map-side-menu site-route-slide-menu ${
          this.isDrawerClosed() && "closed"
        }`}
      >
        <div className="side-menu-wrapper" id="side-menu-scroll-wrapper">
          {this.state.activeEditRouteId && !this.state.editActiveRoute && (
            <div
              style={{ color: activeRoute.hex_color }}
              className="side-menu-title title-edit"
            >
              <h3
                style={{
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                }}
              >
                {activeRoute.siteroute_name}
              </h3>
              <span style={{ minWidth: "3em" }}>
                <i
                  className={"fas fa-edit fa-pull-left clickable"}
                  onClick={() =>
                    this.setState({
                      editActiveRoute: true,
                      editingActiveRouteName: activeRoute.siteroute_name,
                    })
                  }
                  title="Edit Route Name"
                  aria-label="change route name"
                />
                <i
                  onClick={this.toggleColorSelector.bind(this)}
                  title="Edit Route Color"
                  className="fas fa-palette fa-pull-right clickable"
                  aria-label="change route color"
                />
              </span>
            </div>
          )}
          {this.state.editActiveRoute && (
            <div className="side-menu-title title-edit">
              <Input
                type="text"
                value={this.state.editingActiveRouteName}
                onChange={(val) => {
                  this.setState({ editingActiveRouteName: val });
                }}
                title={`Rename ${activeRoute.siteroute_name}`}
              />
              <i className={"fas fa-check"} onClick={this.changeRouteName} />
            </div>
          )}
          {this.state.showColorEdit && (
            <SimpleColorPicker
              colors={this.routeColors}
              onClick={this.chooseColor.bind(this)}
            />
          )}
          {this._renderSiteRouteSeats()}
          <div
            className={`side-menu-select-wrapper ${
              this.state.sideBarClosed && "closed"
            }`}
          >
            <div
              className={`side-menu-option toggle ${
                !this.isDrawerClosed() && "arrow-drawer"
              }`}
              onClick={() =>
                this.setState({ sideBarClosed: !this.state.sideBarClosed })
              }
            >
              <i
                className={`fas ${
                  this.state.sideBarClosed ? "fa-arrow-left" : "fa-arrow-right"
                }`}
                title="Hide Side Menu"
              />
            </div>
            {(this.props.loading || this.state.loading) && (
              <div className={`side-menu-option loading`}>
                <i className="fas fa-asterisk" />
              </div>
            )}
          </div>
        </div>

        <div
          className={`no-print map-side-menu ${
            this.state.sideBarClosed && "closed"
          }`}
        >
          <div className="side-menu-wrapper" id="side-menu-scroll-wrapper">
            {this._renderSideBarClusterTopDisplay()}
            {this._renderSideBarSiteList()}
            {this._renderSiteRoutes()}
          </div>
          {this.state.mode === "Sites" ? (
            <div
              className="mapButtonsPadding"
              style={{
                backgroundColor: "white",
                fontSize: "15px",
                height: "8rem",
                textAlign: "center",
                alignItems: "baseline",
                justifyContent: "flex-start",
              }}
            >
              {this.renderSitePager()}
            </div>
          ) : null}
          {this._renderAddRouteButtons()}
        </div>
      </div>
    );
  };

  renderSitePager() {
    let sites = this.filterSites(this.state.sites);
    if (sites.length > this.state.chunkSize) {
      return (
        <div>
          <i
            className={`fas fa-arrow-left ${
              this.state.nextChunk === 1 ? "disabled" : ""
            }`}
            style={{ padding: "0em .5em" }}
            onClick={() =>
              this.state.nextChunk > 1 &&
              this.setState({ nextChunk: this.state.nextChunk - 1 })
            }
          />
          Sites: {this.getChunkLabel("min")} - {this.getChunkLabel("max")} of{" "}
          {this.getFilteredSiteCount(this.state.columns.sites)}
          <i
            className={`fas fa-arrow-right ${
              this.state.nextChunk === this.getMaxSiteChunk() ? "disabled" : ""
            }`}
            style={{ padding: "0em .5em" }}
            onClick={() =>
              this.state.nextChunk < this.getMaxSiteChunk() &&
              this.setState({ nextChunk: this.state.nextChunk + 1 })
            }
          />
        </div>
      );
    } else {
      return (
        <div>Sites: {this.getFilteredSiteCount(this.state.columns.sites)}</div>
      );
    }
  }

  onDragEnd = async (result) => {
    const { destination, source, draggableId } = result;

    let activeRoute = this.getActiveEditRoute();

    // destination will be null when dropped outside of context.
    if (!destination) {
      return;
    }

    // if it was dropped back in the same column.
    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    ) {
      return;
    }

    // now need to reorder.
    const start = this.state.columns[source.droppableId];
    const end = this.state.columns[destination.droppableId];

    if (source.droppableId !== "sites" && destination.droppableId === "sites") {
      return;
    }

    if (start === end) {
      const newColumnIds = Array.from(start);
      let spliced = newColumnIds.splice(source.index, 1);
      if (spliced.length > 0) {
        newColumnIds.splice(destination.index, 0, spliced[0]);
      }

      const newState = {
        ...this.state,
        columns: {
          ...this.state.columns,
          [destination.droppableId]: newColumnIds,
        },
      };

      // If we aren't starting from sites, then we are reordering seats and need an api call to preserve that order.
      if (source.droppableId !== "sites") {
        let requestData = {
          routeseat: this.state.activeRouteSeat.routeseat_id,
          siteroute: activeRoute.siteroute_id,
        };

        for (let i = 0; i < newColumnIds.length; i++) {
          if (newColumnIds[i].routeseatsite_id) {
            requestData.routeseatsite_id = newColumnIds[i].routeseatsite_id;
          }

          requestData.site = newColumnIds[i].site_id || newColumnIds[i].id;
          requestData.site_order_position = i + 1;

          this.changeSmartOrderStatus(false);

          await updateOrCreateRouteSeatSite(requestData).then((res) => {
            this.setState(newState);
          });
        }

        return;
      }

      this.setState(newState);

      return;
    }

    if (source.droppableId === "sites") {
      // move from one list to another
      const newStart = Array.from(start);
      const newFinish = Array.from(end);

      let item = cloneDeep(
        newStart.find((d) => {
          let _ID;
          if (d.routeseatsite_id) {
            //moving from seat to seat
            _ID = d.routeseatsite_id;
          } else {
            //moving from site bar to seat
            _ID = d.id;
          }
          //draggable id is the routeseatsite_id in a seat and the site_id in the site list
          return _ID === +draggableId;
        })
      );

      if (item) {
        newFinish.splice(destination.index, 0, item);
      }

      this.changeSmartOrderStatus(false);

      const newState = {
        ...this.state,
        columns: {
          ...this.state.columns,
          [source.droppableId]: newStart,
          [destination.droppableId]: newFinish,
        },
      };

      let routeSeat = activeRoute.routeseats.find(
        (obj) => obj.routeseat_id == destination.droppableId
      );
      let dupes = [];
      routeSeat &&
        routeSeat.sites.forEach((val, index) => {
          let site_id = val.id || val.site_id;
          if (
            (site_id === item.id && item.id !== undefined) ||
            (site_id === item.site_id && item.site_id !== undefined)
          ) {
            dupes.push(val);
          }
        });
      // don't add dupe sites
      if (dupes.length) {
        this.props.setInfoFeedMessage({
          id: "site_assigned",
          msg: "Site already assigned to seat",
        });
        return;
      }

      let requestData = {
        routeseat: routeSeat.routeseat_id,
        siteroute: activeRoute.siteroute_id,
        site_order_position: destination.index,
        site: item.id || item.site_id,
      };

      // If we started in sites, then we only need to create a new seat
      updateOrCreateRouteSeatSite(requestData).then((res) => {
        // update the new route seat site with it's routeseatsite_id returned from the api.
        let newSeatSite = newState.columns[destination.droppableId].findIndex(
          (i) => i.routeseatsite_id === undefined
        );
        newState.columns[destination.droppableId][
          newSeatSite
        ].routeseatsite_id = res.routeseatsite_id;
        this.setState(newState);
      });
    } else {
      // If moving from one seat to the other, add it to the new one then delete the old seat site.
      // Also only remove the starting site when moving between seats, otherwise we don't want the side card to disappear.

      // move from one seat to another
      const newStart = Array.from(start);
      const newFinish = Array.from(end);
      let item = cloneDeep(newStart[source.index]);

      if (item) {
        newFinish.splice(destination.index, 0, item);
      }

      const newState = {
        ...this.state,
        smartOrder: false,
        columns: {
          ...this.state.columns,
          [source.droppableId]: newStart,
          [destination.droppableId]: newFinish,
        },
      };

      let routeSeat = activeRoute.routeseats.find(
        (obj) => obj.routeseat_id == destination.droppableId
      );
      let siteExists = routeSeat.sites.find(
        (s) => s.site_id === item.id || s.site_id === item.site_id
      );
      // don't add dupe sites
      if (siteExists) {
        this.props.setInfoFeedMessage({
          id: "site_assigned",
          msg: "Site already assigned to seat",
        });
        return;
      }

      let requestData = {
        routeseat: routeSeat.routeseat_id,
        siteroute: activeRoute.siteroute_id,
        site_order_position: destination.index,
        site: item.id || item.site_id,
      };

      // now it's ok to remove the site from the seat it started in.
      newStart.splice(source.index, 1);
      newState.columns[source.droppableId] = newStart;

      updateOrCreateRouteSeatSite(requestData).then((res) => {
        // update the new seat with it's proper id returned from the api
        let newSeatSite = newState.columns[destination.droppableId].findIndex(
          (i) => i.routeseatsite_id === item.routeseatsite_id
        );
        // clone the reference to item, otherwise it updates to the response routeseatsite and causes issues.
        let routeseatsite = {
          routeseatsite_id: cloneDeep(item).routeseatsite_id,
        };
        newState.columns[destination.droppableId][
          newSeatSite
        ].routeseatsite_id = res.routeseatsite_id;
        deleteRouteSeatSite(routeseatsite).then((response) => {
          this.setState(newState);
        });
      });
    }
  };

  // Because of all the places we need to maintain sites to allow for drag and drop,
  // make sure to remove sites from columns after delete, otherwise that change will not appear.
  syncSiteColumnsAfterDelete(seat_id, site_id) {
    // after doing an api call to remove a site, we probably need to go through and sync up the colums tracking that item?
    let columns = { ...this.state.columns };
    let newSites = columns[seat_id].slice();
    let removedSite = newSites.findIndex(
      (obj) => obj.routeseatsite_id === site_id
    );
    newSites.splice(removedSite, 1);
    columns[seat_id] = newSites;

    this.setState({ columns });
  }

  syncSeatColumnsAfterDelete(seat_id) {
    // after doing an api call to remove a site, we probably need to go through and sync up the colums tracking that item?
    let columns = { ...this.state.columns };
    // get rid of the entire column related to the seat id
    delete columns[seat_id];

    this.setState({ columns });
  }

  isDrawerClosed() {
    let closed = true;
    if (this.state.sideBarClosed) {
      return true;
    } else if (this.state.activeEditRouteId) {
      closed = false;
    }

    return closed;
  }

  //updates the sites state with changes
  //note creation modal returns the site_id as first arg and the full list of notes for a site as second arg.
  handleNoteModalClose = (site_id, siteNotes) => {
    let { sites } = this.state;

    sites = sites.map((site) => {
      if (site.id === site_id) {
        return { ...site, notes: siteNotes };
      } else {
        return site;
      }
    });
    this.setState({ sites });
  };

  handleFilterModalClose = (filters) => {
    this.setState(
      { filterModalOpen: false, filters },
      this.handlePointsOnFilter
    );
  };

  setPageError(msg, timeout = 3000) {
    this.setState(
      {
        pageError: true,
        errMsg: msg,
      },
      setTimeout(() => this.setState({ pageError: false }), timeout)
    );
  }

  _isError = () => {
    const error =
      this.props.sites_error ||
      this.props.siteroutes_error ||
      this.state.pageError;
    // if (error) debugger;
    return error;
  };

  zoomCallBack = (val) => {
    this.setState({ zoom: val });
  };

  render() {
    const { encodedSites } = this.state;

    return (
      <>
        <FloatHeader link="/sitecanvass" />
        <div style={{ width: "100vw", height: "100vh" }}>
          {!!encodedSites.features.length && (
            <BaseMap
              hoveredFeatures={this.state.hoveredFeatures}
              hoveredSource={this.state.hoveredSource}
              handleViewChange={(viewState) => {
                this.setState({
                  viewState,
                  visibleSiteIds: viewState.visiblePoints,
                });
              }}
              sources={[
                {
                  id: "site-points",
                  type: "geojson",
                  data: encodedSites,
                  style: groupedPointStyle,
                  isInteractive: true,
                  selectedFeatures: this.state.selectedSites,
                  onHover: (features, ref) => {
                    let routeSeats = features[0].properties?.data.routeSeats;
                    let currentHoveredFeature = features[0].id;

                    if (routeSeats && !this.state.blockHoverUpdate) {
                      let routeSeatIds = routeSeats
                        .reduce((agg, cur) => {
                          return [
                            ...agg,
                            ...cur.sites.map((site) => site.site_id),
                          ];
                        }, [])
                        .filter((n) => n !== currentHoveredFeature);

                      routeSeatIds.unshift(currentHoveredFeature);

                      this.setState({
                        pseudoHoveredFeatures: routeSeatIds,
                        hoveredSource: "site-points",
                      });
                    }
                  },
                  onEndHover: (features) => {
                    if (!this.state.blockHoverUpdate) {
                      this.setState({
                        pseudoHoveredFeatures: null,
                        hoveredFeatures: null,
                        hoveredSource: null,
                      });
                    }
                  },
                  onClick: (feature) => {
                    this.updateSelectedSites(feature);
                  },
                  popupComponentGenerator: (feature) => {
                    const routeSeats = feature.properties.data.routeSeats;

                    const routeData = {
                      hex_color: feature.properties.routeColor,
                      siteroute_id: feature.properties.routeId,
                      routeseats: routeSeats,
                      created_at: feature.properties.routeCreatedAt,
                      siteroute_name: feature.properties.routeName,
                    };

                    return !this.state.blockPopup
                      ? this.generatePointHoverCard(routeData, feature)
                      : null;
                  },
                },
              ]}
            />
          )}
        </div>
        <InfoTileFeed
          showInfoFeed={true}
          messageStyle={{
            lineHeight: "1.5m",
            color: "#1679c7", // primary text color
            fontWeight: "bold",
            alignItems: "center",
            justifyContent: "center",
            fontSize: ".8em",
            padding: ".5em",
            zIndex: "9999",
          }}
        />
        <DragDropContext onDragEnd={this.onDragEnd}>
          {this._renderSiteRouteSlideMenu()}
        </DragDropContext>

        <SiteNoteModal showCloseIcon center />
        {this.state.filterModalOpen && (
          <SiteFilterModal
            showCloseIcon
            center
            handleOnClose={this.handleFilterModalClose}
            open={true}
            filters={this.state.filters}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  focusedCampaign: state.session.focusedCampaign,
  sites: state.sites.data,
  sites_loading: state.sites.loading,
  sites_error: state.sites.error,
  siteRoutes: state.siteRoutes.data,
  siteroutes_loading: state.siteRoutes.loading,
  siteroutes_error: state.siteRoutes.error,
  loading: state.sites.loading || state.siteRoutes.loading,
  sessionVars: state.session.vars,
});

// TODO: is this necessary on this page?
const mapDispatchToProps = (dispatch) => ({
  removeInfoFeedMessage: (msg) => dispatch(removeInfoFeedMessage(msg)),
  setInfoFeedMessage: (msg) => dispatch(setInfoFeedMessage(msg)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RouteEdit));
